import { createFileRoute, Link } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/')({
    component: AdminHome,
})

function AdminHome() {
    return (
        <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
            {/* Header */}
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-900">
                    Admin Panel
                </h1>
                <p className="mt-2 text-gray-600">
                    Manage and monitor the platform
                </p>
            </div>

            {/* Admin Pages Grid */}
            <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                {/* Dashboard Link */}
                <Link
                    to="/admin/dashboard"
                    className="group block rounded-lg border border-gray-200 bg-white p-6 shadow-sm transition-all hover:border-gray-300 hover:shadow-md"
                >
                    <div className="mb-3 text-4xl">📊</div>
                    <h2 className="mb-2 text-xl font-semibold text-gray-900 group-hover:text-blue-600">
                        Dashboard
                    </h2>
                    <p className="text-gray-600">
                        View platform metrics, active users, and growth
                        statistics
                    </p>
                </Link>

                {/* Pending Users Link */}
                <Link
                    to="/admin/pending-users"
                    className="group block rounded-lg border border-gray-200 bg-white p-6 shadow-sm transition-all hover:border-gray-300 hover:shadow-md"
                >
                    <div className="mb-3 text-4xl">👥</div>
                    <h2 className="mb-2 text-xl font-semibold text-gray-900 group-hover:text-blue-600">
                        Pending Users
                    </h2>
                    <p className="text-gray-600">
                        Review and approve new public account signups
                    </p>
                </Link>
            </div>
        </div>
    )
}
